/* eslint-disable prefer-destructuring */
angular.module('tgaAdmin')
  .controller('EventsController', [
    '$scope', '$state', '$timeout', '$filter', '$uibModal', 'envService',
    'gameService', 'activityService', 'localStorageService', 'eventService', '$q',
    function (
      $scope, $state, $timeout, $filter, $uibModal, envService,
      gameService, activityService, localStorageService, eventService, $q,
    ) {
      if (!envService.read('enableEvents')) {
        $state.go('v1.games');
      }

      $scope.data = {
        games: [],
        activities: [],
        selectedGame: null,
        inProgress: false,
      };

      $scope.starting = false;
      $scope.stopping = false;

      $scope.viewmodel = {
        event_id: 1,
        type: null,
        type_id: null,
      };

      $scope.initialize = function () {
        $scope.loading = true;

        const games = gameService.getGames().then(
          (response) => {
            $scope.data.games = response;
          },
        );

        const activities = activityService.getActivities().then(
          (response) => {
            $scope.data.activities = response;
          },
        );

        const eventData = eventService.getEvent($scope.viewmodel.event_id).then(
          (response) => {
            $scope.viewmodel = response;
          },
        );

        $q.all([games, activities, eventData]).then(() => {
          $scope.loading = false;

          if ($scope.viewmodel.type === 'game' || $scope.viewmodel.type === 'leaderboard') {
            $scope.data.selectedGame = $filter('filter')($scope.data.games, { game_id: $scope.viewmodel.type_id }, true)[0];
            $scope.data.inProgress = true;
          } else if ($scope.viewmodel.type === 'activity') {
            $scope.data.selectedGame = $filter('filter')($scope.data.activities, { activity_id: $scope.viewmodel.type_id }, true)[0];
            $scope.data.inProgress = true;
          } else if ($scope.viewmodel.type === 'global') {
            $scope.data.selectedGame = 'global';
            $scope.data.inProgress = true;
          }
        });
      };

      $scope.actions = {
        selectGame(game) {
          $scope.data.selectedGame = game;
          $scope.viewmodel.type = 'game';
          $scope.viewmodel.type_id = game.game_id;
        },
        selectLeaderboard(game) {
          $scope.data.selectedGame = game;
          $scope.viewmodel.type = 'leaderboard';
          $scope.viewmodel.type_id = game.game_id;
        },
        selectActivity(activity) {
          $scope.data.selectedGame = activity;
          $scope.viewmodel.type = 'activity';
          $scope.viewmodel.type_id = activity.activity_id;
        },
        selectGlobal() {
          $scope.data.selectedGame = 'global';
          $scope.viewmodel.type = 'global';
          $scope.viewmodel.type_id = null;
        },
        start() {
          $scope.starting = true;

          eventService.updateEvent($scope.viewmodel).then(
            () => {
              $scope.data.inProgress = true;
              $scope.starting = false;
            },
          );
        },
        stop() {
          $scope.viewmodel.type = null;
          $scope.viewmodel.type_id = null;

          $scope.stopping = true;

          eventService.updateEvent($scope.viewmodel).then(
            (response) => {
              $scope.data.selectedGame = null;
              $scope.data.inProgress = false;
              $scope.stopping = false;
              $scope.viewmodel = response;
            },
          );
        },
      };

      $scope.initialize();
    },
  ]);
